/**
 * Single source for Surveillance domain / AWS URLs (CM-UI).
 *
 * Override per env (Helm / .env) — never hardcode buckets in charts or clients.
 *
 * CM-API builds full `u`/`fu` on getBets using:
 *   SURVEILLANCE_GRAPH_BASE_URL    (or surveilliance_bucket)
 *   SURVEILLANCE_GRAPH_V2_BASE_URL (or survilliance_buket_url_v2)
 *
 * When the API returns full https `u`/`fu`, charts fetch those as-is.
 * This file is for relative keys / client-side rebuild only — keep VITE_* in
 * sync with the CM-API graph base URLs for the same brand (e.g. 7s).
 */

function trimSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

function envUrl(key: keyof ImportMetaEnv, fallback: string): string {
  const raw = import.meta.env[key]
  const value = typeof raw === 'string' && raw.trim() ? raw.trim() : fallback
  return trimSlash(value)
}

/** Primary rate JSON host — Lab `surveilliance_bucket` / `runner.u`. */
export const SURVEILLANCE_S3_PRIMARY = envUrl(
  'VITE_SURVEILLANCE_S3_BUCKET',
  'https://survilliance-7s.s3.ap-south-1.amazonaws.com',
)

/** Fallback rate JSON host — Lab `survilliance_buket_url_v2` / `runner.fu`. */
export const SURVEILLANCE_S3_FALLBACK = envUrl(
  'VITE_SURVEILLANCE_S3_BUCKET_V2',
  'https://survilliance-v2-7s.s3.ap-south-1.amazonaws.com',
)

export const surveillanceConfig = {
  s3Primary: SURVEILLANCE_S3_PRIMARY,
  s3Fallback: SURVEILLANCE_S3_FALLBACK,
} as const
